import { render, staticRenderFns } from "./paidList.vue?vue&type=template&id=37a9722d"
import script from "./paidList.vue?vue&type=script&lang=ts"
export * from "./paidList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports